<template>
  <div class="gt-uploader-block">
    <section class="gt-uploader-block__tips">
      {{ tips }}
    </section>

    <section class="gt-uploader-block__download-temp">
      <a title="Download Template" :href="templateUrl">{{
        $t("Root.Picker.Download_Template")
      }}</a>
    </section>

    <section class="gt-uploader-block__main">
      <div class="gt-uploader-block__input">
        <input
          :id="id"
          :disabled="loading"
          name="file"
          type="file"
          accept=".xlsx"
          @change="onSlectChange"
        />
        <i class="el-icon-document"></i>
        <span class="gt-uploader-block__file-name">
          {{ fileName || $t("Root.Picker.Select_a_file") }}
        </span>
      </div>

      <div class="gt-uploader-block__start">
        <el-popover
          v-model="popoverShow"
          placement="top"
          trigger="click"
          width="243"
        >
          <p class="gt-uploader-block__popover-tips">
            {{ $t("Root.Picker.Will_overwrite_the_p") }}
          </p>
          <div class="gt-uploader-block__popover-btns">
            <el-button @click="popoverShow = false" type="text" size="small">
              {{ $t("Root.Picker.Cancel") }}
            </el-button>
            <el-button
              :disabled="!file"
              @click="onImportSure"
              size="small"
              type="text"
            >
              {{ $t("Root.Picker.Upload") }}
            </el-button>
          </div>
          <el-button
            :loading="loading"
            type="primary"
            slot="reference"
            :disabled="!file"
          >
            {{ $t("Root.Picker.Upload") }}
          </el-button>
        </el-popover>
      </div>
    </section>
  </div>
</template>

<script>
import Uploader from "@root/lib/uploader.js";
import XLSX from "xlsx";

export default {
  name: "ProductPickerUploadBlock",

  props: {
    tips: {
      type: String
    },
    templateUrl: {
      required: true,
      type: String
    }
  },

  data() {
    return {
      id: `uploaderblock_${Math.random()}`,
      fileName: "",
      file: null,
      loading: false,
      popoverShow: false,
      dataAfterParse: null
    };
  },

  methods: {
    onSlectChange(e) {
      this.file = e.target.files[0];
      this.fileName = this.file.name || "";
    },
    clearFile() {
      this.file = null;
      this.fileName = "";
    },

    onImportSure() {
      if (this.loading) return;

      this.popoverShow = false;

      this.loading = true;

      try {
        let reader = new FileReader();
        reader.onload = async e => {
          let data = e.target.result;
          let workbook = XLSX.read(data, { type: "binary" });
          let sheetData = {};
          // 目前只会读取sheet1的数据
          let sheet1 = workbook.SheetNames[0];

          if (sheet1) {
            sheetData = workbook.Sheets[sheet1];
          }
          console.log(sheetData, 654);

          // start parse
          this.dataAfterParse = await this.onParseData(sheetData);

          this.$emit("change", this.dataAfterParse);
        };

        reader.readAsBinaryString(this.file);

        // clear
        document.getElementById(this.id).value = "";
      } catch (_) {
        console.error(_);
      } finally {
        this.loading = false;
      }
    },

    async onParseData(workbook) {
      let json = [];

      if (workbook) {
        try {
          json = XLSX.utils.sheet_to_json(workbook);
        } catch (_) {
          console.error(_);
        }
      }

      return json;
    }
  }
};
</script>

<style lang="scss">
.gt-uploader-block {
  background: rgba(250, 250, 250, 1);
  padding: 12px 16px;

  &__tips {
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 17px;
    margin-bottom: 12px;
  }

  &__download-temp {
    height: 16px;
    line-height: 16px;
    margin-bottom: 12px;
    a {
      color: $text-color-yellow;

      padding: 0px;
      font-size: 14px;
      border-bottom: 1px solid $text-color-yellow;
    }
  }

  &__main {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  &__input {
    width: 353px;
    height: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(217, 217, 217, 1);
    padding: 0 14px;
    margin-right: 8px;
    cursor: pointer;

    input[name="file"] {
      opacity: 0;
      position: absolute;
    }

    [class*=" el-icon-"],
    [class^="el-icon-"] {
      font-size: 14px;
      color: #979797;
    }
  }

  &__file-name {
    font-size: 14px;
    font-weight: 400;
    color: $text-color-yellow;
  }

  &__popover-tips {
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    word-break: break-word;
    text-align: left;
    // margin-bottom: 4px;
    padding: 10px;
  }

  &__popover-btns {
    .el-button:first-child {
      color: rgba(102, 102, 102, 1);
    }
    display: flex;
    justify-content: flex-end;
  }
}
</style>
